function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */

/**
 * Deferred Promise
 */
var Deferred = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
  }
  /**
   * @returns The {@link Deferred} Promise
   */


  _createClass(Deferred, [{
    key: "promise",
    get: function get() {
      return this._promise;
    }
    /**
     * Rejects this promise
     */

  }, {
    key: "reject",
    value: function reject(reason) {
      this._reject(reason);
    }
    /**
     * Resolves this promise
     */

  }, {
    key: "resolve",
    value: function resolve(value) {
      this._resolve(value);
    }
  }]);

  return Deferred;
}();

export { Deferred as default };